import { useEffect, useRef } from 'react';

import { useTheme } from 'libs/ui/theme';

import { CanvasStyled, RootStyled } from './GradientBackgroundGlobal.styles';
import { WebGLGradient } from './gradient';

export const GradientBackgroundGlobal = () => {
  const { theme } = useTheme();
  const canvasRef = useRef<WebGLGradient>();

  useEffect(() => {
    // eslint-disable-next-line no-new
    canvasRef.current = new WebGLGradient('#gradient-canvas');
    canvasRef.current.initGradient('#gradient-canvas');

    return () => canvasRef.current?.disconnect();
  }, []);

  // Update CSS variables on theme change
  useEffect(() => {
    if (canvasRef.current) {
      canvasRef.current.waitForCssVars();
    }
  }, [theme.palette.mode]);

  return (
    <RootStyled>
      <CanvasStyled id="gradient-canvas" />
    </RootStyled>
  );
};
